import React, { Fragment } from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";

function Input_libas_extendNote(props) {
  const { label, name, ...rest } = props;
  return (
    <Fragment>
      <div className="form-control-customed single_input">
        <div style={{ height: "23px", float: "left" }}>
          <label htmlFor={name}>{label}</label>
        </div>
        
        <div>
          <Field
            className="single_input_text"
            id={name}
            name={name}
            {...rest}
          />
        </div>
        <div>
          <ErrorMessage component={TextError} name={name} />
        </div>
      </div>

      {/* <div className="form-control-customed single_input">
        <div style={{ height: "23px" }}>
          <label htmlFor={name}>{label}</label>
        </div>
        <div>
          <Field
            className="single_input_text"
            id={name}
            name={name}
            {...rest}
          />
          <ErrorMessage component={TextError} name={name} />
        </div>
      </div> */}
    </Fragment>
  );
}

export default Input_libas_extendNote;
